import React, { useState } from 'react'
import { Box, CircularProgress, Fade, Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import DateRangePicker from '@/components/Common/DateRangePicker'
import StyledButton from '@/components/Button/Button'

interface DatePickerModalProps {
  openDate: boolean
  handleDateClose: () => void
  handleDownload: (startDate: Dayjs | null, endDate: Dayjs | null) => void
  handlePending: boolean
}

const DatePickerModal: React.FC<DatePickerModalProps> = ({
  openDate,
  handleDateClose,
  handleDownload,
  handlePending,
}) => {
  const [startDate, setStartDate] = useState<Dayjs | null>(null)
  const [endDate, setEndDate] = useState<Dayjs | null>(null)

  const handleDownloadClick = () => {
    handleDownload(startDate, endDate)
  }

  return (
    <Fade in={openDate}>
      <Box className="sub-admin-modal-style">
        <div className="flex justify-between items-center px-2">
          <div className="text-[22px] font-medium font-sans text-white">
            Select Duration
          </div>
          <div className="model-close" onClick={handleDateClose}>
            <img src="/icon/close icon.png" alt="Close" />
          </div>
        </div>
        {handlePending ? (
          <div className="!min-h-[200px] flex justify-center items-center">
            <CircularProgress className="!text-[#fb5012] !text-[100px]" />
          </div>
        ) : (
          <Typography className="py-5">
            <div className="create-subadmin pb-5 flex flex-col justify-center items-center gap-10">
              <DateRangePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />
              <div>
                <StyledButton
                  className="!shadow-2xl bg-orange-700 !font-sans w-[120px] !h-[45px] !text-[14px]"
                  onClick={() => handleDownloadClick()}
                  disabled={!startDate || !endDate}
                >
                  Download
                </StyledButton>
              </div>
            </div>
          </Typography>
        )}
      </Box>
    </Fade>
  )
}

export default DatePickerModal
